import { TRootState } from 'Redux/Reducers';

export const getLocationCount = (state: TRootState) => state.location.maxCount;
